export const SET_EVENTLIST = 'SET_EVENTLIST'
export const SET_SEARCH = 'SET_SEARCH'
export const SET_TOTAL = 'SET_TOTAL'
export const SET_DATE_RANGE = 'SET_DATE_RANGE'
export const SET_CLEAR_ALL = 'SET_CLEAR_ALL'
export const SET_LOADING = 'SET_LOADING'
export const SET_PAGE = 'SET_PAGE'
export const SET_MONTH_EVENTS = 'SET_MONTH_EVENTS'
export const SET_CATEGORY_LIST = 'SET_CATEGORY_LIST'
export const SET_FILTER = 'SET_FILTER'